import { faCakeCandles } from "@fortawesome/pro-light-svg-icons";

import { Icon } from "@/components";
import { TableColumn } from "@/components/Table/Table";
import { SortParams } from "@/types/types";

import { ListPerson } from "../../schema/list";
import { getOrderStatus } from "../column-utils";

/**
 * Company-fact columns for the list grid, extracted from `allColumns.tsx` so that file keeps
 * shrinking under the 500-line ratchet. Re-exported from `allColumns` — the many
 * `TableColumnConfigs/*` files import them from there.
 */

/**
 * The company name as a person would write it in an email (PREC-2748).
 *
 * Read-only and display-only: the value is resolved by the send path (and the backfill job), never on
 * a grid page load, so it falls back to the raw company name while it is still null.
 */
export const renderNormalizedCompanyNameColumn = (
	ts: (key: string) => string,
	handleCopyClick: (value: string) => void,
	sortingInbox: SortParams
): TableColumn => {
	const orderTitle = "organization.nameNormalized";

	const valueOf = (row: ListPerson): string =>
		row.prospect?.organization?.nameNormalized || row.prospect?.organization?.name || "";

	return {
		title: ts("normalizedCompanyName"),
		width: "fit-content",
		orderTitle,
		orderStatus: getOrderStatus(sortingInbox, orderTitle),
		uid: "normalizedCompanyName",
		hideable: true,
		moveable: true,
		show: false,
		render: (row: ListPerson) => (
			<div>
				<button className="cursor-pointer" onClick={() => handleCopyClick(valueOf(row))}>
					{valueOf(row)}
				</button>
			</div>
		),
	};
};

export const renderFoundedYearColumn = (
	ts: (key: string) => string,
	handleCopyClick: (value: string) => void,
	sortingInbox: SortParams
): TableColumn => {
	const orderTitle = "organization.foundedYear";

	return {
		title: ts("foundedYear"),
		width: "fit-content",
		orderTitle,
		orderStatus: getOrderStatus(sortingInbox, orderTitle),
		uid: "foundedYear",
		hideable: true,
		moveable: true,
		show: false,
		render: (row: ListPerson) => (
			<div className="flex flex-row">
				<button
					className="cursor-pointer mr-2"
					onClick={() =>
						row.prospect?.organization?.foundedYear &&
						handleCopyClick(row.prospect?.organization?.foundedYear?.toString() || "")
					}
				>
					{row.prospect?.organization?.foundedYear}{" "}
					{row.prospect?.organization?.foundedYear && <Icon color="#374151" icon={faCakeCandles} />}
				</button>
			</div>
		),
	};
};

export const renderIndustryColumn = (
	ts: (key: string) => string,
	handleCopyClick: (value: string) => void,
	sortingInbox: SortParams
): TableColumn => {
	const orderTitle = "organization.industry";

	return {
		title: ts("industry"),
		width: "fit-content",
		orderTitle,
		orderStatus: getOrderStatus(sortingInbox, orderTitle),
		uid: "industry",
		hideable: true,
		moveable: true,
		show: true,
		render: (row: ListPerson) => (
			<div>
				<button
					className="cursor-pointer"
					onClick={() =>
						handleCopyClick(
							row.prospect?.organization?.industry?.capitalizeString() ??
								row.mapBusiness?.type ??
								""
						)
					}
				>
					{row.prospect?.organization?.industry?.capitalizeString() ?? row.mapBusiness?.type}
				</button>
			</div>
		),
	};
};
